module.exports = __webpack_public_path__ + "static/assets/148e4f4cfc7a1a253eb52c50bbb635a0.svg";